import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language } from './translations';
type LanguageContextType = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (path: string) => any;
};
const LanguageContext = createContext<LanguageContextType | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Language>(() => {
    const saved = localStorage.getItem('dff-lang') as Language;
    if (saved && translations[saved]) return saved;
    const browserLang = navigator.language.slice(0, 2) as Language;
    if (translations[browserLang]) return browserLang;
    return 'en';
  });
  useEffect(() => {
    localStorage.setItem('dff-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (path: string) => {
    const keys = path.split('.');
    let current: any = translations[lang];
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        // Fallback to English
        let fallback: any = translations['en'];
        for (const k of keys) {
          if (fallback && fallback[k] !== undefined) {
            fallback = fallback[k];
          } else {
            return path; // Return key path if not found even in English
          }
        }
        return fallback;
      }
    }
    return current;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-195">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}